import styles from './Spec1.module.less';
import React, { memo, useEffect } from 'react';
import ConvertOrderQuantity from '@/components/ConvertOrderQuantity/ConvertOrderQuantity'
// import CustomizeImageViewerMulti from '@/components/CustomizeImageViewerMulti/CustomizeImageViewerMulti'
import iconRemark from "@/assets/img/icon/place_order_remark.png";
import Stepper from "@/components/Stepper";
import { t } from "@/utils/i18n";
import { utils, constant } from "@/utils";
import useCorpSettingStore from "@/stores/corp-setting";

import type {
  SpecElementItem,
  UnitPriceItem,
  SpecItem,
} from "@/types/product";
import useRefState from '@/hooks/useRefState';

interface Details {
  [key: string]: SpecsItemDetail
}

interface SpecsItemDetail {
  elements: SpecElementItem[];
  quantity: number;
  skuId: string;
  stock: number;
  price?: number;
  originPrice?: number;
  priceTypeId?: string;
  skuRemark?: string;
}

interface SpecsItemProps {
  detail: Details
  specName: string
  // spec1: SpecsItemDetail[]
  isMultiPrice: boolean
  chooseUnit: UnitPriceItem
  unitPriceArray: UnitPriceItem[]
  productMoqUnitIndex: number
  specId2: string
  specId3: string
  specDetailList: SpecItem[]
  [key: string]: any
  changeSpecElementsValue1: (sku: SpecsItemDetail) => void
  previewImg?: (img: string, elementName?: string) => void
  onEditSkuRemark?: (sku: SpecsItemDetail) => void
  onToggleAddModal?: () => void
}

const { concatenateImageUrl, px2rem } = utils
const {
  product: { IMAGE_DEFAULT },
} = constant

const Spec1: React.FC<SpecsItemProps> = memo((props) => {
  const { corpSetting } = useCorpSettingStore();
  const { currencySymbol } = corpSetting;
  const {
    detail,
    // spec1,
    specName,
    isMultiPrice,
    chooseUnit,
    changeSpecElementsValue1,
    productMoqUnitIndex,
    unitPriceArray,
    specDetailList,
    specId2,
    specId3,
  } = props;
  const [spec1, setSpec1] = useRefState<SpecsItemDetail[]>([]); // 当前规格一列表
  const [isHaveImg, setIsHaveImg] = useRefState(false); // 是否存在 spu 图片

  function loadQuantity() {
    const activeDetail = detail;
    const activeSpecDetailList = specDetailList;
    let currentSpec1: SpecsItemDetail[] = []; // 当前规格一

    if (!activeDetail) return

    if (activeSpecDetailList && activeSpecDetailList.length > 0) {
      // 多规格，循环一次规格一
      activeSpecDetailList[0].specElements.forEach((spec1Item: { elementId: any }) => {
        // 根据几级规格拼装 和encodeSpecs()一致 的 specsId
        let specsId = `SPECS-${spec1Item.elementId}`;

        if (activeSpecDetailList.length >= 2) {
          specsId = `${specsId}-${specId2 || activeSpecDetailList[1].specElements[0].elementId}`;
        }

        if (activeSpecDetailList.length >= 3) {
          specsId = `${specsId}-${specId3 || activeSpecDetailList[2].specElements[0].elementId}`;
        }

        // 直接去detail里匹配对应的值
        currentSpec1.push(activeDetail[specsId]);
      });
    } else {
      // 无规格，只有一个SKU
      currentSpec1 = [activeDetail["SPECS-"]];
    }

    currentSpec1 = currentSpec1.filter((item) => item)
    // 查找规格1的缩略图
    currentSpec1.forEach((specItem) => {
      specItem.elements.forEach((elementItem) => {
        activeSpecDetailList.forEach((specDetailItem) => {
          specDetailItem.specElements.forEach((specElementItem) => {
            if (specElementItem.elementId === elementItem.elementId && specElementItem.uri) {
              elementItem.uri = specElementItem.uri;
            }
          });
        });
      });
    });
    const isHaveImg = currentSpec1.findIndex(item => {
      return item.elements.length && item.elements[0].uri
    }) > -1

    setIsHaveImg(isHaveImg)
    setSpec1(currentSpec1);
  }

  function handleChangeSpecElementsValue(value: string, index: number) {
    const sku = spec1[index];
    sku.quantity = Number(value);
    changeSpecElementsValue1(sku);
  }

  const SpecItem = () => {
    return spec1.map((item: SpecsItemDetail, index: number) => {
      return (
        <div className={styles["first-specification-item"]} key={'spec1_' + item.skuId}>
          <div className={styles['spec-item']}>
            <div className={styles['spec-item-name']}>
              <div
                className={styles["img-card"]}
              >
                {isHaveImg && (
                  <img
                    className={styles["img-wrap"]}
                    src={`${item.elements[0].uri ? concatenateImageUrl(`${item.elements[0].uri}_140`) : IMAGE_DEFAULT}`}
                    onClick={() => {
                      props.previewImg && props.previewImg(item.elements[0].uri || IMAGE_DEFAULT, item.elements[0].elementName);
                    }}
                    onError={(e: any) => { e.target.src = IMAGE_DEFAULT }}
                  />
                )}
                <div className={styles['img-bd']}>
                  <div className={styles['text-wrap']}>
                    <div className={styles['text-item']}>
                      <div className={styles["img-title"]}>
                        {item.elements[0].elementName}
                      </div>
                      {/* 不同规格不同价格  */}
                      {(isMultiPrice && Number(item.price) >= 0) && (
                        <div className={styles["requirelist-price"]}>
                          {currencySymbol}
                          {item.price}/{chooseUnit.priceUnitName}
                        </div>
                      )}
                      <div className={styles["kp-requirelist-stock"]}>
                        <span>{t("库存")}</span> 
                        {item.stock}
                        {chooseUnit.unitName}
                      </div>
                      <div className={styles['sku-remark']} onClick={()=> props.onEditSkuRemark && props.onEditSkuRemark(item)}>
                        <span className="ep">{item.skuRemark || t('添加备注')}</span>
                        { !!item.skuRemark && <img src={iconRemark} className={styles["remark-icon"]} />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles['spec-item-value']}>
              <div className={styles['step-wrap']}>
                <Stepper
                  initialValue={String(Number(item.quantity) || 0)}
                  index={index}
                  stock={item.stock || 0}
                  quantity={chooseUnit.productMoqQty || 1}
                  isDebounce={true}
                  unitName={chooseUnit.unitName || ""}
                  onChange={handleChangeSpecElementsValue}
                />
              </div>
              <div className={styles['text-wrap']}>
                <ConvertOrderQuantity
                  moqUnitIndex={productMoqUnitIndex}
                  unitList={unitPriceArray || []}
                  quantity={Number(item.quantity) || 0}
                />
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  useEffect(() => {
    loadQuantity();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail, specId2, specId3])

  return (
    <div className={styles['spec-wrap']}>
      {
        specDetailList.length > 0 && (
          <>
            <div className={styles['hd']} style={{ paddingRight: px2rem(30) }}>
              <div className={styles["type-name"]}>
                {specName}
              </div>
              {props.onToggleAddModal && (<button
                className={styles["batch-add-button"]}
                hover-class="sureBtnhover"
                onClick={() => props.onToggleAddModal && props.onToggleAddModal()}
              >
                {t("批量加购")}
              </button>)}
            </div>
            <SpecItem />
          </>
        )
      }

      {/* 无规格（样式小小不同，因此分开写）  */}
      {
        (specDetailList.length === 0 && spec1.length) && (
          <div className={styles["first-specification-item"]} style={{ paddingTop: "0" }}>
            <div className={styles['spec-item']}>
              <div className={styles['spec-item-name']}>
                <div className={styles["spec-label"]}>{t("购买数量")}</div>
                <div className={styles["kp-remaining-stock"]}>
                  {t("库存")}
                  {spec1[0].stock}
                  {chooseUnit.unitName}
                </div>
              </div>
              <div className={styles['spec-item-value']}>
                <div className={styles['step-wrap']}>
                  <Stepper
                    initialValue={String(spec1[0].quantity)}
                    index={0}
                    stock={spec1[0].stock}
                    quantity={chooseUnit.productMoqQty}
                    isDebounce={true}
                    unitName={chooseUnit.unitName || ""}
                    onChange={handleChangeSpecElementsValue}
                  />
                </div>
                <div className={styles['text-wrap']}>
                  <ConvertOrderQuantity
                    moqUnitIndex={productMoqUnitIndex}
                    unitList={unitPriceArray || []}
                    quantity={Number(spec1[0].quantity) || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
})

export default Spec1